import React, {useState} from 'react';
import {Alert, Button, CircularProgress, FormControlLabel, Stack, Switch, Typography} from '@mui/material';
import GroupsIcon from '@mui/icons-material/Groups';
import {CardHeader, CardWrapper, Description, Title,} from './styles';
import {useDashboardContext} from "../../../Dashboard";
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {Loading} from "../../../../Loading";
import {ModalDialog} from "../../ModalDialog";

export const NoOneGroup = ({onConnect}) => {
    const {VK_CONNECT_DATA} = useDashboardContext();
    return (
        <Alert color={"warning"} sx={{alignItems: "center"}}>
            {VK_CONNECT_DATA.noOne}
            <Button variant="contained" onClick={onConnect} sx={{
                textTransform: 'none',
                borderRadius: 2,
                backgroundColor: '#d81b60',
                marginLeft: 1,
            }}>
                {VK_CONNECT_DATA.connectTitle}
            </Button>
        </Alert>
    )
}

const Group = ({group, isLite}) => {
    const [loading, setLoading] = useState(false);
    const [joined, setJoined] = useState(group.joined);
    const [open, setOpen] = useState(false);
    const {editGroupManager} = useDashboardContext();
    const {VK_CONNECT_DATA} = useDashboardContext();

    const editManager = async () => {
        setLoading(true);
        await editGroupManager(joined ? "" : "editor", group.id);
        setJoined(joined => !joined);
        setLoading(false);
        setOpen(true);
    }

    return (
        <Stack direction={"row"} sx={{gap: 1}}>
            {loading && <Loading/>}
            <ModalDialog open={open} setOpen={setOpen} title={group.name} subtitle={VK_CONNECT_DATA.subtitle}>
                <Stack direction={"row"} sx={{alignItems: "center", gap: 1, mb: 2}}>
                    <CheckCircleIcon color="success"/>
                    {joined ? VK_CONNECT_DATA.successConnected : VK_CONNECT_DATA.successDisconnected}
                </Stack>
            </ModalDialog>
            {isLite ? (
                <Stack direction={"row"} sx={{gap: 1, alignItems: "center"}}>
                    <VerifiedUserIcon color={"success"}/>
                    <img width={50} height={50} src={group.photo_50} alt={""} style={{borderRadius: 8}}/>
                    <Typography>{group.name}</Typography>
                </Stack>
            ) : (
                <FormControlLabel
                    control={<Switch disabled={loading} checked={joined} onClick={editManager}/>}
                    label={
                        <Stack direction={"row"} sx={{gap: 1, alignItems: "center"}}>
                            <img width={50} height={50} src={group.photo_50} alt={""} style={{borderRadius: 8}}/>
                            <Typography>{group.name}</Typography>
                        </Stack>
                    }
                />
            )}

        </Stack>
    )
}
const Groups = ({isLite, onConnect}) => {
    const {groups, groupsError} = useDashboardContext();

    if (groupsError) return <Alert color={"error"}>Ошибка: не удалось загрузить группы</Alert>
    if (!groups) return <CircularProgress/>

    const connectedGroups = groups.filter(g => !isLite || g.joined);

    return (
        <Stack sx={{gap: 1}}>
            {connectedGroups.length ? (
                connectedGroups.map(group => <Group isLite={isLite} group={group} key={group.id}/>)
            ) : (
                <NoOneGroup onConnect={onConnect}/>
            )}
        </Stack>
    )
}


export default function VkConnectCard({isLite, onConnect}) {
    const {VK_CONNECT_DATA} = useDashboardContext();

    return (
        <CardWrapper>
            <CardHeader><GroupsIcon color="primary"/><Title>{VK_CONNECT_DATA.title}</Title></CardHeader>
            <Description>{VK_CONNECT_DATA.description}</Description>
            <Groups isLite={isLite} onConnect={onConnect}/>
        </CardWrapper>
    );
}
